import { Input } from '@angular/core';
import { PaymentMethodModel } from '../../../shared/models/payment-method.model';

export abstract class PaymentPaymentOption {
    @Input() paymentMethod: PaymentMethodModel;

    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFields() {
        return Object
        .keys(this.paymentMethod.extra_fields)
        .map(slug => {
            return {
                slug: slug,
                value: this.paymentMethod.extra_fields[slug]
            };
        });
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/payment/payment/option/payment.payment.option.ts